import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonType } from '@kubit/web-ui-components/button/types';
import { ElementOrIcon } from '@kubit/web-ui-components/elementOrIcon';
import { pickAriaProps } from '@kubit/web-ui-components/utils/aria';
import React from 'react';
import { AnimatedIconButton } from './components/animatedIconButton';
import { ParentContainer } from './iconButton.styled';
export const IconButtonStandAlone = React.forwardRef(function IconButtonStandAlone({ type = ButtonType.BUTTON, ...props }, ref) {
    const dataTestId = 'icon-button';
    const ariaProps = pickAriaProps(props);
    return (_jsx(ParentContainer, { ...ariaProps, ref: ref, as: props.onClick ? 'button' : 'span', "data-testid": dataTestId, disabled: props.disabled, styles: props.styles, type: props.onClick ? type : undefined, onClick: props.onClick, children: !props.twistedIcon ? (_jsx(ElementOrIcon, { customIconStyles: { ...props.styles?.icon }, ...props.icon, onClick: undefined })) : (_jsx(AnimatedIconButton, { ...props })) }));
});
//# sourceMappingURL=iconButtonStandAlone.js.map